<template lang="pug">
.checkin-modal-container(v-if="show", @touchmove.prevent)
  img.light(
    src="https://m.hellobike.com/resource/AppPlatformH5/fuli/asDuEbp0aP83sAXOg6hCp.png"
  )
  .body
    .calendar
      .vip-icon(v-if="currentlyIsVip")
    .title
      .main
        .normal {{didSignToday?'签到成功':'未签到'}}
        .normal(v-if="showVipTitle") ，
        .red(v-if="showVipTitle") 超级会员已享3倍奖励
      .sub
        span 获得
        span(style="color: #ff710c") {{todayNum}}
        span 个奖励金
    .check-in
      .row-1
        CoinIcon.icon(
          :lottie="index === activeIndex",
          v-for="(item, index) in row1",
          :key="item.text",
          :item="item"
        )
      .row-2
        CoinIcon.icon(
          :lottie="index === activeIndex - 3",
          v-for="(item, index) in row2",
          :key="item.text",
          :item="item"
        )
    .go-vip-banner(v-if="showVipBanner && isAPP")
      .left-icon
      .middle-text
        .middle-text-first
          .normal 超级会员签到
          .red 奖励
          .red(style="font-size: 0.15rem;") X
          .red.num 3
          .red 倍
        .middle-text-second 享奖励金兑超值好物
      .right-btn(@click="goVipPage('app')") 去看看
    .go-vip-banner(v-else-if="showVipBanner && isAliMP")
      .middle-text(style="margin-left: 0.02rem;")
        .middle-text-first
          .normal 超级会员在APP签到
          .red 奖励
          .red(style="font-size: 0.15rem;") X
          .red.num 6
          .red 倍
        .middle-text-second 享奖励金兑超值好物
      .right-btn(@click="goVipPage('aliMP')") 去看看
      .background-img
    .go-vip-banner(v-else-if="currentlyIsVip && isAliMP")
      .left-icon
      .middle-text
        .middle-text-first
          .normal 去APP签到
          .red 奖励
          .red(style="font-size: 0.15rem;") X
          .red.num 6
          .red 倍
        .middle-text-second 享奖励金兑超值好物
      .right-btn(@click="goAPP") 去APP
    .coupon(@click="location" v-else-if="couponStatus && isAliMP")
      .left
        img.img(:src='coupon.picUrl')
        .describe
          .title {{coupon.goodName}}
          .subtitle
            .count {{coupon.bountyCount}}
            .detail 奖励金兑换
      .right
        .exchange 可兑换
    .btn.flex-mid(@click="close") 知道了
  .shadow
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { env } from '@hb/NBridge/lib/h5';
import { startApp } from '@/utils/index';
import SPM from '../common/spm';
import CoinIcon from './coin-icon';

export default {
  components: {
    CoinIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    days: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
    coupon: {
      type: Object,
      default: () => ({}),
    },
    currentlyIsVip: {
      type: Boolean,
      default: false,
    },
    bonusTotal: {
      type: Number,
      default: 0,
    },
    repeatSignDesc: {
      type: String,
      default: null,
    },
    bountyCountToday: {
      type: [Number, String],
      default: 0.0,
    },
    canOpenTask: {
      type: Boolean,
      default: false,
    },
    didSignToday: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      env,
      isTaskOpen: false,
    };
  },
  computed: {
    row1() {
      return (this.days || []).slice(0, 3) || [{}, {}, {}];
    },
    row2() {
      return (this.days || []).slice(3, 7) || [{}, {}, {}];
    },
    couponStatus() {
      return this.coupon && Object.keys(this.coupon).length > 0;
    },
    showVipBanner() {
      return this.bonusTotal < 1 && !this.currentlyIsVip;
    },
    isAliMP() {
      return env.isAliMP || env.isAliMPMonitor;
    },
    isAPP() {
      return env.isEasyBikeApp;
    },
    showVipTitle() {
      return this.currentlyIsVip && this.isAPP && !this.repeatSignDesc;
    },
    todayNum() {
      return this.bountyCountToday;
    },
  },
  watch: {
    coupon: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          UBT.moduleExpose({
            pageId: 'Welfare',
            categoryId: 'platform',
            moduleId: 'platform_popcoupon',
            contentId: 'platform_popcoupon',
            exposureTimes: 1,
            businessInfo: {
              itemname: v.goodName,
            },
          });
        }
      },
    },
    show(v) {
      if (v) {
        if (this.timeOutId) {
          clearTimeout(this.timeOutId);
        }
        this.timeOutId = setTimeout(() => {
          if (!this.isTaskOpen && this.canOpenTask) {
            this.$emit('taskOpen');
            UBT.moduleExpose({
              pageId: 'Welfare',
              categoryId: 'platform',
              moduleId: 'growexchange',
              contentId: 'growexchange',
              exposureTimes: 1,
              businessInfo: {},
            });
            this.status();
          }
        }, 2000);
        if (this.showVipBanner && this.isAPP) {
          UBT.moduleExpose({
            pageId: 'Welfare',
            categoryId: 'platform',
            moduleId: 'platform_daily_pop',
            contentId: 'platform_daily_pop',
            exposureTimes: 1,
            businessInfo: {},
          });
        } else if (this.showVipBanner && this.isAliMP) {
          UBT.moduleExpose({
            pageId: 'welfare_new',
            categoryId: 'platform',
            moduleId: 'platform_daily_pop_alipay',
            contentId: 'platform_daily_pop_alipay',
            exposureTimes: 1,
            businessInfo: {},
          });
        }

        // 签到弹窗曝光
        SPM.moduleExpose({
          moduleId: 'Welfare_oldsignpop',
          contentId: 'Welfare_oldsignpop',
          businessInfo: {},
        });
      }
    },
  },
  methods: {
    status() {
      this.$emit('update:show', false);
    },
    close() {
      if (this.canOpenTask) {
        this.isTaskOpen = true;
        this.$emit('taskOpen');
      }
      this.status();

      // 签到弹窗点击埋点
      SPM.clickButton({
        buttonName: 'Welfare_oldsignpop',
        businessInfo: {},
      });
    },
    location() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'platform_popcoupon',
        categoryId: 'platform',
        businessInfo: {
          itemname: this.coupon.goodName,
        },
      });
      this.status();
      // this.$emit('toFloor', 'welfare_bountyExchange');
    },
    async goVipPage(params) {
      if (params === 'app') {
        await UBT.clickButton({
          pageId: 'Welfare',
          buttonName: 'platform_daily_pop',
          categoryId: 'platform',
          businessInfo: {},
        });
      } else if (params === 'aliMP') {
        await UBT.clickButton({
          pageId: 'welfare_new',
          buttonName: 'platform_daily_pop_alipay',
          categoryId: 'platform',
          businessInfo: {},
        });
      }
      this.$router.push({
        path: '/vip/v2/transfer',
        query: {
          adsource: params === 'aliMP' ? 'fulizhongxinpopalipay' : 'fulizhongxinpopapp',
        },
      });
    },
    goUrl(url, download = false) {
      if (download && (env.isAliMP || env.isAliMPMonitor)) {
        startApp(url);
        return;
      }
      window.location.href = url;
    },
    goAPP() {
      this.goUrl('https://h.c3x.me/29u3nN', true);
    },
  },
};
</script>

<style lang="less" scoped>
.checkin-modal-container {
  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }

  .light {
    z-index: 109;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 1.59rem;
    width: 2.47rem;
  }

  .body {
    width: 2.97rem;
    height: 4.42rem;
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    z-index: 110;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 44%;
    background: #fff;
    border-radius: 0.13rem;
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/fuli/BRSwXHpgNNSnwhzMBDI2Z.png);
    background-size: 100% 1.17rem;
    background-position-y: 0;
    background-repeat: no-repeat;
    padding: 0.36rem 0 0.24rem;

    .calendar {
      position: absolute;
      left: 50%;
      top: -0.8rem;
      transform: translateX(-50%);
      z-index: 111;
      width: 1.86rem;
      height: 1.1rem;
      background: url(https://m.hellobike.com/resource/AppPlatformH5/fuli/kWRzmG6UVfrRXF0r2ZIgk.png) no-repeat top/100% 100%;

      .vip-icon {
        position: absolute;
        bottom: 0;
        right: 0.4rem;
        width: 0.38rem;
        height: 0.38rem;
        background: url('https://m.hellobike.com/resource/helloyun/18536/w_-7hyZRqk.png') no-repeat top/100% 100%;
      }
    }

    .title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 0.42rem;

      .main {
        display: flex;
        font-size: 0.18rem;
        font-weight: 500;
        color: #000;
        line-height: 0.25rem;

        .red {
          color: #ff6011;
        }
      }

      .sub {
        font-size: 0.14rem;
        font-weight: 500;
        color: #5a6066;
        line-height: 0.2rem;

        .color {
          color: #ff5d0d;
          font-family: "DIN Alternate Bold", sans-serif;
        }
      }
    }

    .btn {
      width: 2.57rem;
      height: 0.4rem;
      background: linear-gradient(137deg, #ff8e67 0%, #ff5103 100%);
      border-radius: 0.08rem;
      font-size: 0.14rem;
      font-weight: 500;
      color: #fff;
    }

    .check-in {
      margin-bottom: 0.14rem;

      .row-1 {
        display: flex;
        justify-content: center;
        margin-bottom: 0.13rem;
      }

      .row-2 {
        display: flex;
        justify-content: center;
      }
    }

    .go-vip-banner {
      margin-bottom: 0.2rem;
      width: 2.55rem;
      height: 0.6rem;
      position: relative;
      border-radius: 0.12rem;
      background: linear-gradient(137deg, #fff0c6 0%, #ffea99 100%);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.1rem;
      overflow: hidden;
      .z-level() {
        z-index: 50;
      }

      .left-icon {
        flex-shrink: 0;
        margin-left: -0.04rem;
        width: 0.41rem;
        height: 0.4rem;
        background: url(https://m.hellobike.com/resource/helloyun/18536/A9QI-s2llE.png) no-repeat top/100% 100%;
        .z-level();
      }

      .middle-text {
        width: 100%;
        flex-grow: 0;
        margin-left: 0.02rem;
        .z-level();

        &-first {
          display: flex;
          color: #3b1401;
          font-family: PingFang SC, sans-serif;
          font-size: 0.13rem;
          font-weight: 600;
          line-height: 0.12rem;

          .red {
            color: #f54311;
          }

          .num {
            font-family: "DIN Alternate Bold", sans-serif;
            font-size: 0.19rem;
            font-weight: 700;
          }
        }

        &-second {
          margin-top: 0.07rem;
          color: #3b1401;
          font-family: PingFang SC, sans-serif;
          font-size: 0.11rem;
          font-weight: 400;
          line-height: 0.12rem;
        }
      }

      .right-btn {
        flex-shrink: 0;
        width: 0.5rem;
        height: 0.24rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0.12rem;
        background-color: #ff6c30;
        color: #fff;
        font-family: PingFang SC, sans-serif;
        font-size: 0.11rem;
        font-weight: 600;
        .z-level();
      }

      .background-img {
        position: absolute;
        right: 0.51rem;
        width: 0.77rem;
        height: 100%;
        background: url(https://m.hellobike.com/resource/helloyun/18536/O94Tr_icon.png) no-repeat top/100% 100%;
      }
    }

    .coupon {
      display: flex;
      padding: 0.12rem;
      justify-content: center;
      align-items: center;
      border-radius: 0.08rem;
      background: rgba(255, 237, 226, 0.3);
      margin-bottom: 0.2rem;

      .left {
        display: flex;

        .img {
          max-width: 0.34rem;
          max-height: 0.36rem;
          margin-right: 0.06rem;
        }

        .describe {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          min-width: 1.5rem;

          .title {
            color: #242729;
            line-height: 0.12rem;
            font-size: 0.12rem;
            font-weight: 500;
            margin-bottom: 0;
          }

          .subtitle {
            display: flex;
            font-size: 0.12rem;
            color: #5a6066;
            line-height: 0.12rem;
            margin-top: 0.1rem;
          }

          .count {
            color: #ff5526;
          }
        }
      }

      .exchange {
        border: 0.01rem solid #ff7123;
        border-radius: 0.04rem;
        line-height: 0.14rem;
        color: #ff7224;
        font-size: 0.1rem;
        padding: 0.05rem 0.06rem;
      }
    }
  }
}
</style>
